// Starter block templates the user can pick from.
import { defaultBlock } from "./blockRenderer";

function b(type, data) {
  const blk = defaultBlock(type);
  return { ...blk, data: { ...blk.data, ...(data || {}) } };
}

export const STARTER_TEMPLATES = [
  {
    id: "blank",
    name: "Blank canvas",
    subject: "",
    description: "Start from scratch — add blocks as you go.",
    blocks: [
      b("header", { tagline: "RAHI-feed" }),
      b("social"),
      b("footer"),
    ],
  },
  {
    id: "quarterly",
    name: "Quarterly impact",
    subject: "RAHI-feed · Quarterly Impact Update",
    description: "Hero + intro + stats + story + CTA — for periodic supporter updates.",
    blocks: [
      b("header", { tagline: "Quarterly Impact" }),
      b("hero", {
        headline: "3 million meals · 150,000 lives",
        subhead: "Here's what we built together this quarter, thanks to your continued support.",
      }),
      b("text", {
        title: "Dear %recipient.name%,",
        body: "Every meal you helped fund this quarter reached a child who would otherwise have gone without. Below are the highlights from the field.",
      }),
      b("stats", {
        title: "The numbers",
        rows: [
          { number: "3.1M", label: "Meals served" },
          { number: "152K", label: "Lives touched" },
          { number: "318", label: "Partner schools" },
        ],
      }),
      b("divider"),
      b("text", {
        title: "From the field",
        body: "Add a short story or note from the team here. Keep it human — supporters respond to specifics.",
      }),
      b("cta", { label: "Continue supporting", url: "https://riseagainsthungerindia.org/donate" }),
      b("social"),
      b("footer"),
    ],
  },
  {
    id: "appeal",
    name: "Donation appeal",
    subject: "An urgent appeal — please help",
    description: "Hero image + urgent ask + CTA — for fundraising drives.",
    blocks: [
      b("header", { tagline: "Urgent appeal" }),
      b("hero", {
        headline: "Help us feed 50,000 more children this year",
        subhead: "Every ₹1,000 puts a child in school with a hot meal for a full month.",
        image_url: "",
      }),
      b("text", {
        body: "Dear %recipient.name%,\n\nWe are scaling up to reach 50,000 additional children by March. Your gift today is the difference between a child showing up to class — or staying home.",
      }),
      b("cta", { label: "Donate now", url: "https://riseagainsthungerindia.org/donate" }),
      b("divider"),
      b("text", {
        title: "Where your money goes",
        body: "₹1,000 = one child fed for one month.\n₹12,000 = one child fed for a full school year.\n₹60,000 = an entire classroom of 60 children fed for a month.",
      }),
      b("social"),
      b("footer"),
    ],
  },
  {
    id: "story",
    name: "Story spotlight",
    subject: "Meet Asha — a story from the field",
    description: "One photo, one story — perfect for monthly newsletters.",
    blocks: [
      b("header", { tagline: "Field story" }),
      b("hero", {
        headline: "Meet Asha, 9, who hasn't missed a day of school since September.",
        subhead: "",
        image_url: "",
      }),
      b("image", { src: "", alt: "Asha at her school", caption: "Asha at Government Primary School, Hyderabad" }),
      b("text", {
        body: "Until last year, Asha walked 4 km to school on an empty stomach. Now, thanks to our meal programme, she eats before her first class.\n\nAttendance at her school has jumped 38% in six months.",
      }),
      b("cta", { label: "Sponsor another classroom", url: "https://riseagainsthungerindia.org/donate" }),
      b("social"),
      b("footer"),
    ],
  },
  {
    id: "assam-flood-2026",
    name: "Assam Flood Relief Appeal 2026",
    subject: "Assam is under water. 600,000 families need us now.",
    description: "Emergency appeal for the Assam monsoon flood response — hero, situation, response so far, plan, CTAs.",
    blocks: [
      b("header", { tagline: "Emergency appeal" }),
      b("hero", {
        headline: "Assam is under water. 600,000 families need us now.",
        subhead: "Devastating floods have displaced tens of thousands across Sivasagar, Charaideo, and Jorhat. Rise Against Hunger India is on the ground — but we need your help to reach more families.",
        image_url: "https://riseagainsthungerindia.org/api/static/blog-images/assam-flood-devastation-aerial.jpg",
        alt: "Aerial view of devastating floods in Assam — over 600,000 people affected",
      }),
      b("text", {
        body: "Dear %recipient.name%,\n\nBetween 21–24 July, torrential monsoon rains overwhelmed the Brahmaputra and its 50+ tributaries. Homes have collapsed. Livestock is lost. Standing crops are destroyed. Families are living in relief camps with nothing but the clothes they escaped in.\n\nThis is one of the worst floods Upper Assam has seen in years — and it is unfolding right now.",
      }),
      b("stats", {
        title: "The scale of the crisis",
        rows: [
          { number: "6L+", label: "people affected" },
          { number: "60–100", label: "lives lost" },
          { number: "10Ks", label: "displaced in camps" },
        ],
      }),
      b("image", {
        src: "https://riseagainsthungerindia.org/api/static/blog-images/assam-flood-devastation-homes.jpg",
        alt: "Collapsed and damaged homes in Assam — residents salvage materials from the wreckage",
        caption: "Homes destroyed by the floods — families attempt to salvage what remains",
      }),
      b("cta", { label: "Donate now", url: "https://rzp.io/rzp/rahiassamfloodrelief" }),
      b("divider"),
      b("text", {
        title: "Our response so far",
        body: "Our teams are already in Nazira Circle, Sivasagar District — working alongside local authorities, community volunteers and humanitarian partners to reach families who have lost everything.",
      }),
      b("stats", {
        title: "",
        rows: [
          { number: "750", label: "households — food kits" },
          { number: "300", label: "hot meals served" },
          { number: "200", label: "dignity kits for women" },
        ],
      }),
      b("text", {
        body: "We are also coordinating drinking water distribution, psychosocial support, and household relief with government departments.",
      }),
      b("image", {
        src: "https://riseagainsthungerindia.org/api/static/blog-images/assam-flood-meal-distribution.jpg",
        alt: "Rise Against Hunger India team serving freshly cooked meals to flood-affected families",
        caption: "Our team serving freshly cooked meals in Sivasagar district",
      }),
      b("cta", { label: "Help us reach more families", url: "https://rzp.io/rzp/rahiassamfloodrelief" }),
      b("divider"),
      b("text", {
        title: "What we plan to do — next three months",
        body: "Timely, coordinated and dignified relief. Our commitment to the affected population over the next 90 days:\n\n• 1,00,000 packaged ready-to-cook fortified meals\n• 2,000 food kits (cereals, pulses, spices, oil, salt, sugar)\n• 5,000 freshly cooked meals\n• 1,000 personal hygiene kits and sanitary pads\n• 1,000 household kits (utensils, water containers, bedding)\n• 500 ready-to-eat kits\n\nTotal estimated cost: ₹58,00,000. Every rupee goes directly to families who have lost everything.",
      }),
      b("cta", { label: "Donate to the appeal", url: "https://rzp.io/rzp/rahiassamfloodrelief" }),
      b("divider"),
      b("text", {
        body: "Donations are eligible for tax exemption under Section 80G of the Income Tax Act.\n\nFor any queries, write to us at info@riseagainsthungerindia.org or call 9108403329.\n\nThis is a developing situation — we will keep you updated as our operations progress.",
      }),
      b("social"),
      b("footer", { org: "Rise Against Hunger India", address: "info@riseagainsthungerindia.org · 9108403329" }),
    ],
  },
  {
    id: "hunger-action-month-2026",
    name: "Hunger Action Month 2026",
    subject: "Take the Hunger Action Pledge and Make a Difference This Hunger Action Month",
    description: "October — Hunger Action Month appeal with pledge, volunteer, ambassador, quiz, and donate CTAs.",
    blocks: [
      b("header", { tagline: "Hunger Action Month · October 2026" }),
      b("hero", {
        headline: "Innovate today. Nourish tomorrow.",
        subhead: "Every October, through Hunger Action Month, we bring people together to learn more about hunger and nutrition and, most importantly, to take action towards a hunger-free world.",
        image_url: "https://customer-assets-rejwkqb3.emergentagent.net/job_mailer-platform-1/artifacts/dwd00adi_HAM_Logo.jpg",
        alt: "Hunger Action Month · Committed towards a hunger-free India · Innovate today. Nourish tomorrow.",
      }),
      b("text", {
        body: "Dear %recipient.name%,\n\nGreetings from Rise Against Hunger India!\n\nThis year, we are observing Hunger Action Month under the theme: Innovate Today. Nourish Tomorrow.\n\nAs someone who has already chosen to contribute your time and energy to our work, we invite you to be part of this month-long movement.",
      }),
      b("text", {
        body: "Hunger and food insecurity affect millions of people, and the causes are often complex. Rising living costs, unemployment, emergencies, natural disasters and limited access to nutritious food can make it difficult for families to put healthy meals on the table.\n\nWhile there is no single solution to hunger, every action matters.",
      }),
      b("image", {
        src: "https://customer-assets-rejwkqb3.emergentagent.net/job_mailer-platform-1/artifacts/gljnzg88_WFD%20Theme2026.jpg",
        alt: "World Food Day · 16 October 2026 · Innovate today. Nourish tomorrow.",
        caption: "World Food Day — 16 October 2026",
      }),
      b("divider"),
      b("text", {
        title: "What can you do this Hunger Action Month?",
        body: "Five simple ways to make a difference — pick one, or do all five.",
      }),
      b("text", {
        body: "✅ Take the Hunger Action Pledge\nCommit to simple everyday actions that support healthier eating habits, reduce food waste and promote food security.",
      }),
      b("cta", { label: "Take the Hunger Action Pledge", url: "https://riseagainsthungerindia.org/pledge" }),
      b("text", {
        body: "✅ Volunteer\nJoin our meal packaging program and help provide nutritious meals to vulnerable communities.\nCurrently available in Bengaluru, Mumbai, Delhi, Hyderabad and Bhubaneswar.",
      }),
      b("cta", { label: "Enroll as a Volunteer", url: "https://riseagainsthungerindia.org/volunteer" }),
      b("text", {
        body: "✅ Join Our Packathon on October 16\nBe part of our World Food Day packathon — a hands-on volunteer event where you help pack thousands of nutritious meals for vulnerable communities. Hosted at our warehouses in Bengaluru, Delhi, Mumbai, Bhubaneswar and Hyderabad.",
      }),
      b("cta", { label: "Enroll in the Packathon", url: "https://riseagainsthungerindia.org/packathon" }),
      b("text", {
        body: "✅ Become a Social Ambassador\nHelp spread awareness about hunger, nutrition and responsible food practices by sharing messages through your social networks.\n\nUse #HungerActionMonth #RiseAgainstHungerIndia and tag @RiseAgainstHungerIndia",
      }),
      b("text", {
        body: "✅ Test Your Knowledge\nTake our short Food & Nutrition Quiz and learn more about healthy food choices.",
      }),
      b("cta", { label: "Take the Hunger Quiz", url: "https://riseagainsthungerindia.org/quiz" }),
      b("text", {
        body: "✅ Donate\nSupport our efforts towards nutrition security, resilient livelihoods and stronger communities.",
      }),
      b("cta", { label: "Donate Now", url: "https://riseagainsthungerindia.org/donate" }),
      b("divider"),
      b("text", {
        body: "Together, we can create a future where everyone has access to nutritious food and the opportunity to thrive.\n\nThank you for being part of the movement.\n\nWarm regards,\nRise Against Hunger India",
      }),
      b("social"),
      b("footer", { org: "Rise Against Hunger India", address: "info@riseagainsthungerindia.org · 9108403329" }),
    ],
  },
];
